function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Validator } from 'vee-validate';
import { isFunction } from '@cloud-sn/v-utils';

var FormValidator =
/*#__PURE__*/
function (_Validator) {
  _inherits(FormValidator, _Validator);

  function FormValidator() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormValidator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormValidator)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.validateMessages = {
      $$_form: {}
    };
    return _this;
  }

  _createClass(FormValidator, [{
    key: "getMessage",
    value: function getMessage(fieldName, ruleName, data) {
      var validateMessages = this.validateMessages;
      var message = null;
      var fieldMsgs = validateMessages[fieldName] || {};
      var formMsgs = validateMessages.$$_form || {};

      if (fieldMsgs && ruleName in fieldMsgs) {
        message = fieldMsgs[ruleName];
      } else if (ruleName in formMsgs) {
        message = formMsgs[ruleName];
      }

      return isFunction(message) ? message.apply(void 0, _toConsumableArray(data)) : message;
    }
  }, {
    key: "_formatErrorMessage",
    value: function _formatErrorMessage(field, rule) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var targetName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var formatName = targetName;
      /* eslint-disable no-underscore-dangle */

      var name = this._getFieldDisplayName(field);

      if (!formatName && Validator.isTargetRule(rule.name)) {
        var selector = rule.params[0];

        if (selector) {
          selector = selector.replace(/^\$/, '').replace(/Ref$/, '');
          formatName = this.dictionary.getAttribute(this.locale, selector, selector);
        }
      }

      var params = this._getLocalizedParams(rule, formatName);

      var errorMessage = this.getMessage(field.name, rule.name, [name, params, data]);
      return errorMessage || _get(_getPrototypeOf(FormValidator.prototype), "_formatErrorMessage", this).call(this, field, rule, data, formatName);
      /* eslint-enable no-underscore-dangle */
    }
  }, {
    key: "locale",
    get: function get() {
      return this.formLocale || this.dictionary.locale;
    },
    set: function set(value) {
      this.formLocale = value;
    }
  }]);

  return FormValidator;
}(Validator);

export { FormValidator as default };